"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.101 8.033c0 4.365 3.552 7.916 7.916 7.916 4.365 0 7.916-3.551 7.916-7.916S12.382.117 8.017.117C3.653.117.101 3.668.101 8.033Zm1 0a6.924 6.924 0 0 1 6.916-6.916 6.924 6.924 0 0 1 6.916 6.916 6.924 6.924 0 0 1-6.916 6.916 6.924 6.924 0 0 1-6.916-6.916ZM6.3 11.951h1V4.116h-1v7.835Zm3.635 0h-1V4.116h1v7.835Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.096 12.038c0 6.543 5.324 11.866 11.866 11.866s11.865-5.323 11.865-11.866c0-6.542-5.323-11.865-11.865-11.865S.096 5.496.096 12.038Zm1.125 0c0-5.922 4.818-10.74 10.74-10.74 5.923 0 10.74 4.818 10.74 10.74 0 5.923-4.817 10.741-10.74 10.741-5.922 0-10.74-4.818-10.74-10.74Zm12.186 5.972h1.125V6.067h-1.125V18.01Zm-2.89 0H9.392V6.067h1.125V18.01Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.128 16.051c0 8.723 7.098 15.821 15.821 15.821 8.723 0 15.82-7.098 15.82-15.821 0-8.723-7.097-15.82-15.82-15.82C7.226.231.128 7.328.128 16.051Zm1.5 0c0-7.896 6.424-14.32 14.321-14.32 7.896 0 14.32 6.424 14.32 14.32 0 7.897-6.424 14.321-14.32 14.321-7.897 0-14.321-6.424-14.321-14.321Zm16.248 7.962h1.5V8.089h-1.5v15.924Zm-3.854 0h-1.5V8.089h1.5v15.924Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.06 24.027c0 13.195 10.736 23.931 23.931 23.931 13.196 0 23.931-10.736 23.931-23.931C47.922 10.831 37.187.095 23.991.095 10.796.095.06 10.831.06 24.027Zm1.875 0c0-12.162 9.895-22.057 22.056-22.057 12.162 0 22.056 9.895 22.056 22.057 0 12.161-9.894 22.056-22.056 22.056-12.161 0-22.056-9.895-22.056-22.056ZM18.97 36.175h1.875V11.879H18.97v24.296Zm10.042 0h-1.875V11.879h1.875v24.296Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.08 32.036c0 17.594 14.314 31.908 31.908 31.908S63.896 49.63 63.896 32.036C63.896 14.441 49.582.127 31.988.127S.08 14.441.08 32.036Zm2.5 0c0-16.216 13.193-29.409 29.408-29.409 16.216 0 29.408 13.193 29.408 29.409 0 16.215-13.192 29.408-29.408 29.408-16.215 0-29.408-13.193-29.408-29.408Zm22.713 16.197h2.5V15.838h-2.5v32.395Zm13.39 0h-2.5V15.838h2.5v32.395Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconPauseCircle = function IconPauseCircle(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Pause Circle' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "PauseCircle"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconPauseCircle.sizes = [16, 24, 32, 48, 64];
IconPauseCircle.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconPauseCircle;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/PauseCircle.js
// module id = 2434
// module chunks = 0